import React, { useState, useEffect } from 'react';
import { generateExplanation } from '../api/sonarAPI';

function InputSection({ 
  topic, 
  setTopic, 
  onClear, 
  loading, 
  setLoading, 
  setExplanation, 
  complexityLevel,
  apiKey,
  setApiKey,
  onExplain,
  onFeatureClick
}) {

  // const [apiKey, setApiKey] = useState(localStorage.getItem('sonarApiKey') || '');
  const [showApiInput, setShowApiInput] = useState(!apiKey);

  useEffect(() => {
    // Save API key to localStorage when it changes
    if (apiKey) {
      localStorage.setItem('sonarApiKey', apiKey);
    }
  }, [apiKey]);

  const handleExplain = async () => {
    if (!topic.trim()) return;
    if (!apiKey.trim()) {
      setExplanation("Please enter your Sonar API key first.");
      setShowApiInput(true);
      return;
    }
    
    // Check if onExplain prop exists before calling it
    if (typeof onExplain === 'function') {
      onExplain(() => {
        setLoading(true);
        generateExplanation(topic, complexityLevel, apiKey)
          .then(result => {
            setExplanation(result);
          })
          .catch(error => {
            setExplanation("Sorry, there was an error generating the explanation. Please check your API key and try again.");
          })
          .finally(() => {
            setLoading(false);
          });
      });
    } else {
      // Fallback to original behavior if onExplain isn't provided
      setLoading(true);
      try {
        const result = await generateExplanation(topic, complexityLevel, apiKey);
        setExplanation(result);
      } catch (error) {
        setExplanation("Sorry, there was an error generating the explanation. Please check your API key and try again.");
      } finally {
        setLoading(false);
      }
    }
  };



  // const exampleTopics = [
  //   "Global Warming",
  //   "Black Holes",
  //   "DNA Replication",
  //   "Blockchain Technology",
  //   "Machine Learning",
  //   "Game Theory"
  // ];

  // const setExampleTopic = (example) => {
  //   setTopic(example);
  // };

  return (
    <div className="input-section">
      
      {showApiInput ? (
        <div className="api-key-section">
          <h3 className="slider-title">Enter your Perplexity Sonar API key:</h3>
          <div className="api-input-container">
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder=""
              className="api-key-input"
            />
            <button 
              onClick={() => setShowApiInput(false)}
              disabled={!apiKey.trim()}
              className="save-api-btn"
            >
              Save Key
            </button>
          </div>
          <p className="api-key-info">
            Your API key is stored locally on your device and never sent to our servers.
          </p>
        </div>
      ) : (
        <div className="api-key-status">
          <span ><b>Sonar API Key:</b> ••••••••{apiKey.slice(-4)}</span>
          <button 
            onClick={() => setShowApiInput(true)} 
            className="change-api-btn"
          >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="black">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
          </svg>
          </button>
        </div>
      )}

    <div className="textarea-container">
      <textarea 
        className='search-container'
        id="complex-input" 
        value={topic}
        onChange={(e) => setTopic(e.target.value)}
        placeholder="Enter a complex topic or paragraph... (e.g. Global Warming, Black Holes, DNA Replication, Game Theory)"
        disabled={loading}
      />

      {/* <div className="example-topics">
        <p>Try these examples:</p>
        <div className="topic-chips">
          {exampleTopics.map((example, index) => (
            <button 
              key={index}
              className="topic-chip" 
              onClick={() => setExampleTopic(example)}
              disabled={loading}
            >
              {example}
            </button>
          ))}
        </div>
      </div> */}

      <div className="textarea-buttons">
        <button 
          className='learn-button'
          onClick={handleExplain}
          disabled={loading || !topic.trim()}
        >
          Explain 🤷🏻 
        </button>
        <button 
          id="learning-path"
          onClick={() => typeof onFeatureClick === 'function' ? onFeatureClick('learningPath') : null}
          disabled={loading || !topic.trim()}
          className='learn-button'
        >
          Roadmap ❯❯❯❯❯ 
        </button>
        <button 
          id="generate-metaphor"
          onClick={() => typeof onFeatureClick === 'function' ? onFeatureClick('metaphor') : null}
          disabled={loading || !topic.trim()}
          className='learn-button'
        >
          Metaphors 🎭 
        </button>
        <button 
          id="create-quiz"
          onClick={() => typeof onFeatureClick === 'function' ? onFeatureClick('quiz') : null}
          disabled={loading || !topic.trim()}
          className='learn-button'
        >
          Quiz 💡
        </button>
        <button onClick={onClear}>Clear</button>
      </div>
    </div>
    </div>
  );
}

export default InputSection;